// @flow
import * as d3 from 'd3';
import type { DataType } from './Types';
import RelaxItemType from './Relax';
import relax from './Relax';
import * as $ from 'jquery';


window.console.log("EXPOSED: window.require2")
window.require2 = __webpack_require__; // myLibDef.js to allow javascript console to access as require2(34)

type GraphOptionsType = {
  width: number,
  height: number,
  heightplusNDs: Number,
  jitter: boolean,
  jitterAmount: number,
  nondetectPosition: number,
  margin: {
    top: number,
    right: number,
    bottom: number,
    left: number,
  },
  measurement: {
    strokeColor: string,
    fillColor: string,
    fillColor_ND: string,
    opacity: number,
    strokeColor_NDremoved: string,
    strokeColor_NDconverted: string
  },
  userMeasurement: {
    fillColor: string,
    labelOffset: number,
    labelWidth: number,
    labelHeight: number,
    triangleSize: number,
  }
}

if (!jssettingsH['graphs.height'])
{
  jssettingsH['graphs.height'] = 950;  // myLibDef.js
}

//
// see pfas-exchange#57 get extent/bounds of svg that is currently off-screen (due to tabs)
//
function ssi_svgBBox(svgEl: any) {
  let tempDiv = document.createElement('div')
  tempDiv.setAttribute('style', "position:absolute; visibility:hidden; width:0; height:0")

  if (document.body !== null) {
    document.body.appendChild(tempDiv)
  } else {
    console.error('document.body is null');
  }

  
  let tempSvg = document.createElementNS("http://www.w3.org/2000/svg", 'svg')
  tempDiv.appendChild(tempSvg)
  let tempEl = (svgEl: any).cloneNode(true)
  tempSvg.appendChild(tempEl)
  let bb = (tempEl: any).getBBox()  
  if (document.body !== null)  {
    document.body.removeChild(tempDiv)
  }
  return bb
}

class Graph {
  options : GraphOptionsType = {
    width: 570,
    height: 750,
    heightplusNDs: jssettingsH['graphs.height'],
    jitter: true,
    jitterAmount: 20,
    nondetectPosition: 720,
    margin: {
      top: 50,
      right: 10,
      bottom: 60,
      left: 150,
    },
    measurement: {
      strokeColor: 'blue',
      strokeColor_NDconverted: 'red',
      strokeColor_NDremoved: 'green',
      fillColor: 'transparent',
      fillColor_ND: 'gray',
      opacity: 0.5,
    },
    userMeasurement: {
      fillColor: 'orange',
      labelOffset: 50,
      labelWidth: 320,
      labelHeight: 30,
      triangleSize: 120
    }

  }

  y: any = d3.scaleLog()
  yAxis: any = d3.axisLeft()
  center : number = 0

  svg: Record<string, any> = {}
  yAxisContainer: any = {}
  yAxisTitle: any = {}
  guidelines: any = {}
  measurements: any = {}
  NDs: any = {}
  userMeasurement: any = {}

  constructor(container : string, options : Object = {}) {
    this.options = Object.assign(this.options, options);
    this.center = this.options.margin.left + (this.options.width - this.options.margin.left - this.options.margin.right) / 2;

    const compound_id = d3.select(container).attr('data-compound-id')

    this.svg = d3.select(container)
      .append('svg')
      .attr('width', this.options.width)
      .attr('height', this.options.heightplusNDs)
      .attr('id', 'id-svg-compound-'+compound_id);

    //
    // Scales and axes
    //
    this.y.range([this.options.height - this.options.margin.bottom, this.options.margin.top]);

    // Show tick labels if the tick is a power of 10, otherwise show nothing
    // const yAxisTickFormat = (x) => Math.log10(x) == Math.floor(Math.log10(x)) ? x : '';

    // Show tick labels -- 1,2,4,6,8,10,20,40,60,80,100,200,400,600,800,1000,2000
    const roundDecimal = (x: any) => Number((x).toFixed(8)); // .00001 instead of .000099999999999
    const roundSig = (x: any, y: any) => 1 * Number.parseFloat(Number.parseFloat(x).toPrecision(y)); //1* to get "1e+1" to convert back to 1
    const yAxisTickFormat = (x: any) => Math.round(x / Math.pow(10,-1+Math.ceil(Math.log10(x)))) % 2 == 0 ? roundSig(x,1) : '';

    this.yAxis = d3.axisLeft(this.y)
      .ticks(5)
      .tickFormat(yAxisTickFormat)

    this.yAxisContainer = this.svg.append('g')
      .attr('transform', `translate(${this.options.margin.left - 20}, 0)`);

    this.yAxisTitle = this.svg.append('text')
      .attr('class', 'y-axis-title')
      .attr('transform', `translate(${this.options.margin.left - 70}, ${this.options.margin.top + (this.options.height - this.options.margin.top - this.options.margin.bottom) / 2}) rotate(-90)`)
      .attr('text-anchor', 'middle')
      .text("Concentration"); 

  } /* end constructor() */

  jitter(x : number, factor:number) : number {
    let spread = factor * this.options.jitterAmount;
    return x + Math.random() * spread - spread / 2
  }



  rendergraph(data : DataType, multinames_csv: string, userM_csv: string, measurementw_csv: string, unitw: string) : void {

    // NEW WAY: 1) use "measurements.c_value" and "guidelines.c_level" and the unit is unit_c=data.compound.unit not "mg/L"
    // 2) userM is now in unit_c (not mg/L)
    // but also note to the user that they entered their data as "(measurementw unitw)" which is the same thing
    // 
    // ORIGINAL WAY: mg/L -- 2receive  (graph.render)
    // Setup scales and axes
    // extent based on
    // 1. measurements.value
    // 2. guidelines.level
    // 3. userM
 
    if (!window.compoundVars) window.compoundVars = [];
    window.compoundVars.push(data);
    window.console.log("EXPOSED: window.compoundVars["+(window.compoundVars.length-1)+"]")    


    let userM_a: any = userM_csv.split(";");
    userM_a = userM_a.map(Number);
    let userM1 = userM_a[0];  
    let userM2 = userM_a[1];  

    //DEBUG
    //userM_a.push("30");
    //userM_a.push("40");

    const presence = (value: any) => {
      if (value === null || value === undefined) return null;
      if (typeof value === 'string' && value.trim() === '') return null;
      if (Array.isArray(value) && value.length === 0) return null;
      if (typeof value === 'object' && Object.keys(value).length === 0) return null;
      return value;
    };

    //convert0
    const allDataPoints = data.compound.measurements.map((d) => d.c_value)
      .concat(data.compound.guidelines.map((d) => d.c_level))
      .concat(userM_a);

    let waterORblood = "water";
    if (data.compound.name.search("in blood") > -1) {
      waterORblood = "blood";
    }
    let detection_limit = 2.0; // 2.0 ng/L
    if (waterORblood == "blood") detection_limit = 0.1;  // 0.1 ng/ml
    if (data.compound.slug == "epahazardindex2023_in_water") 
    {
      detection_limit = 1.0*(presence(data.compound.combo_compounds_jsonH['nondetect_grid_uppervalue']) || 2.0);  // 0.0015 unitless
    }

    let allDataPointsPlus: any = allDataPoints
    if (allDataPointsPlus.length == 1) {
      allDataPointsPlus.push(allDataPointsPlus[0] * 1.01)  // make sure an upper tick mark appears
    }
    allDataPointsPlus.push(detection_limit) // if the graph is not at least as low as DL (like if you have all NDs in data POFDA), weird things happen in the ND grid calculations

    let extent_data = d3.extent(allDataPointsPlus.filter((d: any) => d > 0))
    this.y.domain(extent_data).nice()
    let extent_graph_ORIG = this.y.domain()   //in units of the data
   
    //
    // make sure the lower limit is not RIGHT at lower end of data
    //
    extent_data[0] *= 0.99  
    this.y.domain(extent_data).nice()
    let extent_graph = this.y.domain()   //in units of the data
    this.yAxisContainer.call(this.yAxis);

    //
    // fix the units on the y-axis-title using value in the data 
    //
    let y_axis_txt = "Concentration (" + data.compound.c_unit + ")";
    let yaxis = this.svg.selectAll('.y-axis-title')
    yaxis.text(y_axis_txt);

    //old -- updates ALL graphs, not just this one
    //$(".y-axis-title").html(y_axis_txt); //  + " unitw="+unitw

    //
    // part1/3 Measurements (use m.c_value which is in c_unit)
    //
    let measurements = this.svg.append('g')
       .attr('class', 'd3top-measurements-parent')
       .attr('transform', 'translate(0, 0)')

    let m1 = measurements.selectAll('.measurement')
       .data(data.compound.measurements)
       .data(data.compound.measurements.filter((m) => m.c_value > 0));  // hide NDs

    m1.enter()
      .append('circle')
        .attr('class', 'measurement')
        .attr('r', 3)
        .attr('stroke',  (m) => { 
            if (m.code == 'NDconverted') 
              return this.options.measurement.strokeColor_NDconverted; 
            else if (m.code == 'NDremoved') 
              return this.options.measurement.strokeColor_NDremoved; 
            else 
              return this.options.measurement.strokeColor;
          })
        .attr('fill', this.options.measurement.fillColor)
        .attr('opacity', this.options.measurement.opacity)
      .merge(m1)
        .attr('cx', (m) => this.jitter(this.options.margin.left,(m.code.search('ND')>-1 ? 3:1)) + (m.code.search('donothing')>-1 ? 0:100))
        .attr('cy', (m) => (m.c_value == 0 ? this.options.nondetectPosition : this.y(m.c_value)));

    //this.measurements.
    //m1.exit().remove();

    //
    // part1b/3 Non-detect Measurements (use m.c_value which is in c_unit)
    // Q: add .style('pointer-events', 'none') to the NDs?
    //
    // translate start to height of 2.0 ng/L on y-axis scale
    //

    ///move above
    ///let waterORblood = "water";
    ///if (data.compound.name.search("in blood") > -1) {
    ///  waterORblood = "blood";
    ///}

    ///let detection_limit = 2.0; // 2.0 ng/L
    ///if (waterORblood == "blood") detection_limit = 0.1;  // 0.1 ng/ml

    let nondetects = this.svg.append('g')
      .attr('class', 'd3top-nondetects-parent')

    //nondetects.attr('transform', `translate(100,${this.y(detection_limit)})`)

    let nd1 = nondetects.selectAll('.NDmeasurement')
       .data(data.compound.measurements)
       .data(data.compound.measurements.filter((m) => m.c_value == 0));  // a d3.selection only NDs

    let ndgrid:{ [key: string]: any } = {}

    let nd_method = ""

    let dataset_json: { [key: string]: any } = data.compound.m_dataset_json;
    nd_method = dataset_json["graphs_nondetects_display_method"] || ""

    if (nd_method == "") 
    {
      if (waterORblood == "water") nd_method = "grid_right";
      if (waterORblood == "blood") nd_method = "grid_below";
    }

    if (nd_method == "grid_below")
    {
      ndgrid['method'] = "grid_below";
      ndgrid['cols'] = 25;
      ndgrid['pixelspacing'] = 10;
      ndgrid['translate'] = `translate(${this.options.margin.left+0},${this.options.nondetectPosition})`; // bottom of graph // this.options.margin.left
    } 
    
    if (nd_method == "grid_right")
    {
      ndgrid['calc_DL'] = detection_limit;
      ndgrid['calc_extent'] = extent_graph;
      ndgrid['calc_extent_ORIG'] = extent_graph_ORIG;
      ndgrid['method'] = "grid_right";
      ndgrid['count'] = nd1.enter().size();
      ndgrid['top'] = Math.round(this.y(ndgrid['calc_DL']));
      ndgrid['bottom'] = Math.round(this.y(ndgrid['calc_extent'][0]));
      ndgrid['minheight'] = ndgrid['bottom']-ndgrid['top'];
      ndgrid['width'] = 250;
      ndgrid['mincols'] = 10;  // NOT USED
      ndgrid['maxcols'] = 25.0;
      ndgrid['pixelspacing'] = 10;
      ndgrid['minrows'] = Math.ceil(ndgrid['minheight']/ndgrid['pixelspacing']);
      ndgrid['translate'] = `translate(${this.options.margin.left+100},${this.y(detection_limit)})`; // ndgrid shift right be 100px

      // calculate ndgrid['cols']
      ndgrid['cols'] = 25;
      if ((ndgrid['count'] / ndgrid['minrows']) < 1.0) {
        ndgrid['cols'] = 1;
      } else if ((ndgrid['count'] / ndgrid['minrows']) > ndgrid['maxcols']) { 
        ndgrid['cols'] = Math.floor(ndgrid['maxcols']);  // might therefore be a little too tall, that's OK
      } else {
        ndgrid['cols'] = Math.floor(ndgrid['count'] / ndgrid['minrows']);   // 173/10 => 17, should be exact tallness
      }

    }

    //move parent box
    nondetects.attr('transform', ndgrid['translate']);
    console.log(data.compound.abbreviation)
    console.log(ndgrid)

    // .attr('fill', this.options.measurement.fillColor_ND)
    nd1.enter()
      .append('circle')
        .attr('class', 'NDmeasurement')
        .attr('r', 3)
        .attr('stroke', this.options.measurement.fillColor_ND)
        .attr('fill', 'white')
        .attr('opacity', this.options.measurement.opacity)
      .merge(nd1)
        .attr('cx', (m,i) => 5 + (ndgrid['pixelspacing'] * (i % ndgrid['cols'])))  // 5=shift dot right by width of circle
        .attr('cy', (m,i) => 5 + (ndgrid['pixelspacing'] * Math.floor(i / ndgrid['cols'])));   // 5=shift dot down by width of circle

        //.attr('cy', (m,i) => (this.options.nondetectPosition) + (10 * Math.floor(i / 25)));

    //this.NDs.
    //nd1.exit().remove();

    //
    // part 2b/3 -- NDs tooltip / popover
    // make a single transparent region for a NDs tooltip using a bootstap popover rather than attaching to each circle above  
    //.attr('transform', 'translate(150,720)')
    let bb_nd = ssi_svgBBox(nondetects.node()); //.getBBox();  
    let bbox_height = bb_nd.y + bb_nd.height;

    let cid = data.compound.id;
    let data_title =   jssettingsH[cid][`text.graphs.merged.nondetects.heading`];
    let data_content = jssettingsH[cid][`text.graphs.merged.nondetects.text`];

    this.svg.append('rect')
      .attr('transform', ndgrid['translate'])
      .attr('width', 250)
      .attr('height', bbox_height+20)  // big enough to mouseover
      .attr('fill', 'transparent')
      .attr('class', 'poplabel')
      .attr('data-toggle' ,"popover tooltip-NDs")
      .attr('data-title', data_title) // popover text
      .attr('data-placement', "top")
      .attr('data-content', data_content);

    //
    // part2/3 Guidelines (use gd.c_level and c_unit and report original g_level and g_unit if you wish)
    //

    // Build label array to prevent overlaps --- XXX fix to take into account the multi labels not just userM1

    let labels = data.compound.guidelines.map((gd) => ({
      y: gd.c_level == 0 ? this.options.nondetectPosition : this.y(gd.c_level),
      height: 25,
      movable: true
    }));

    const labels_usermeasurements_i_offset = data.compound.guidelines.length;

    // below: + 5 so that the orange boxes are not stacked directly on top of each other
    labels = labels.concat([{
      y: (userM1 == 0 ? this.options.nondetectPosition : this.y(userM1)),
      height: this.options.userMeasurement.labelHeight + 5,
      movable: false
    }]);
    if (userM2 > 0) {
      labels = labels.concat([{
        y: (userM2 == 0 ? this.options.nondetectPosition : this.y(userM2)),
        height: this.options.userMeasurement.labelHeight + 5,
        movable: true
      }]);
    }

    const relaxedLabels = relax(labels);

    this.guidelines = this.svg.selectAll('.guideline')
      .data(data.compound.guidelines);

    // Enter
    const guidelinesEnter = this.guidelines.enter()
      .append('g')
        .attr('class', 'guideline');

    const line = d3.line()
      .x((d) => d.x)
      .y((d) => d.y)
      .curve(d3.curveBasis);
    
    guidelinesEnter.append('path')
        .attr('fill', 'transparent')
        .attr('stroke', (gd) => gd.csslinecolor);

    guidelinesEnter.append('text')
      .attr('alignment-baseline', 'middle')
      .attr('dominant-baseline', 'middle')
      .attr('class', 'poplabel')
      .attr('data-toggle', 'popover tooltip-guidelines')
      .attr('data-placement', 'right');

    // Update

    const local_c_unit = data.compound.c_unit // "mg/L"

    // relaxedLabels -- guidelines part 1/2 -- the labels
    guidelinesEnter
      .merge(this.guidelines)
      .attr('transform', (gd) => `translate(${this.options.margin.left}, ${gd.c_level == 0 ? this.options.nondetectPosition : this.y(gd.c_level)})`)
      .select('text')
        .text((gd) => gd.name)
        .attr('transform', (gd, i) => `translate(50, ${relaxedLabels[i].y - (gd.c_level == 0 ? this.options.nondetectPosition: this.y(gd.c_level))})`)
        .attr('data-title', (gd) => {
            // popover text
            if (local_c_unit === gd.g_unit)
              return gd.longname + ": " + gd.g_levelORreadable +" "+ gd.g_unit    //gd.c_level + " " + local_c_unit
            else
              return gd.longname + ": " + gd.c_level + " " + local_c_unit //+ " (" + gd.g_levelORreadable +" "+ gd.g_unit + ")" // " (in the guideline units: " + g_levelORreadable
          }
        )
        .attr('data-content', (gd) => gd.description)
        .attr('stroke', (gd) => gd.csslinecolor);

    // relaxedLabels -- guidelines part 2/2 -- the curvy line    
    guidelinesEnter
      .merge(this.guidelines)
      .select('path')
        .attr('d', (gd, i) => line([
          { x: -15, y: 0 },
          { x: 0, y: 0 },
          { x: 20, y: 0 },
          { x: 30, y: relaxedLabels[i].y - (gd.c_level == 0 ? this.options.nondetectPosition : this.y(gd.c_level)) },
          { x: 45, y: relaxedLabels[i].y - (gd.c_level == 0 ? this.options.nondetectPosition : this.y(gd.c_level)) },
        ]));

    // Exit
    this.guidelines.exit().remove();

    //
    // part3/3 User measurement/s (userMeasurement is in c_unit)
    //

    //userM_a: add additional datapoints here for combined measurements
    this.userMeasurement = this.svg.selectAll('.userMeasurement')
      .data(userM_a) 
      .data(userM_a.filter((m) => Number(m) > 0));  // hide NDs

    // UM - part 1/5 the containing <g>  
    //d3 => data(), enter(), append()
    const userMeasurementEnter = this.userMeasurement.enter()
      .append('g')
      .attr('class', 'your-result');
    
    // UM - part 2/5 circle <circle> (inside the <g>)
    userMeasurementEnter.append('circle')
      .attr('r', 7)
      .attr('fill', this.options.userMeasurement.fillColor)
      .attr('stroke', 'white')
      .attr('stroke-width', 1);

    // User measurement Label

    // UM - part 3/5 -- little triangle <path> (inside the <g>)
    const triangle = d3.symbol()
      .type(d3.symbolTriangle)
      .size(this.options.userMeasurement.triangleSize);
    userMeasurementEnter.append('path')
      .attr('d', triangle)
      .attr('transform', `translate(${this.options.userMeasurement.labelOffset}, 0) rotate(-90)`)
      .attr('fill', this.options.userMeasurement.fillColor);

    // UM - part 4/5 -- the yellow/orange <rect> (inside the <g>)
    userMeasurementEnter.append('rect')
      .attr('transform', `translate(${this.options.userMeasurement.labelOffset},  ${-this.options.userMeasurement.labelHeight / 2})`)
      .attr('width', this.options.userMeasurement.labelWidth)
      .attr('height', this.options.userMeasurement.labelHeight)
      .attr('fill', this.options.userMeasurement.fillColor);

    let measurementw_a = measurementw_csv.split(";"); //allow multiple user points for multi values
    let multinames_a = multinames_csv.split(";"); 

    // UM - part 5/5 -- the white <text> that appears to be "inside" the <rect> but is really a sibling 
    userMeasurementEnter.append('text')
      .attr('alignment-baseline', 'middle')
      .attr('dominant-baseline', 'middle')
      .attr('class', 'poplabel')
      .attr('data-toggle', 'popover tooltip-usermeasurement')
      .attr('data-placement', 'right')
      .attr('data-title', (um,i) => {
        // popover text

        // let is_combined = (i>0) 
        let is_combined = data.compound.is_combo  //i is old way (multiple dots per graph), is_combo is new way
        let combined = is_combined ? "combined" : "";
        let name = multinames_a[i]; // compound name or guideline combo name
        let result = `Your ${combined} result`;
        if (name) result += " (" + name + ")";
        return result;
      })
      .attr('transform', `translate(${this.options.userMeasurement.labelOffset + 10}, 0)`)
      .attr('fill', 'white')
      .text((um,i) => {
        let combined = (data.compound.is_combo) ? "combined" : "";
        if(um == 0) {
          return `Your ${combined} result: not detected`;
        }
        else {
          let mw = measurementw_a[i];
          let result = "";
          //let local_c_unit = "XXX"; //DEBUG -- force non-match
          if (local_c_unit === unitw)
            result = `Your ${combined} result: ${um} ${local_c_unit}`; 
          else
            result = `Your ${combined} result: ${um} ${local_c_unit} (${mw} ${unitw}) `;  // um is being sent in units c_unit.  XXX do not repeat if c_unit == unitw?
          return  result
          }
      });

    // Update part 1
    // relaxedLabels -- usermeasurements part 1/2 -- move the entire <g> to the location of the dot and then adjust the <rect>
    userMeasurementEnter
      .merge(this.userMeasurement)
      .attr('transform', (um) => {
        let yval = (um == 0) ? this.options.nondetectPosition+20 : this.y(um);  //+20 for NDs so doesn't overlap dots
        return `translate(${this.options.margin.left}, ${yval})`;
      })
      .select('rect')
        .attr('transform', (um, i) => {
          let yval = (um == 0) ? this.options.nondetectPosition+20 : this.y(um);  //+20 for NDs so doesn't overlap dots

          let j =i;  if (j>1) j=1;  // we currently only calculate relax for userM1 and userM2
          j += labels_usermeasurements_i_offset; // relaxedLabels[i] for usermeasurements come after the guidelines
          let yrelaxed = relaxedLabels[j].y - yval - (this.options.userMeasurement.labelHeight / 2);

          return `translate(50, ${yrelaxed})`
        });

    // Update part 2
    // relaxedLabels -- usermeasurements part 1/2 --  adjust the <text>
    // + 10 to have a slight left-margin
    userMeasurementEnter
      .select('text')
        .attr('transform', (um, i) => {
          let yval = (um == 0) ? this.options.nondetectPosition+20 : this.y(um);  //+20 for NDs so doesn't overlap dots

          let j =i;  if (j>1) j=1;  // we currently only calculate relax for userM1 and userM2
          j += labels_usermeasurements_i_offset; // relaxedLabels[i] for usermeasurements come after the guidelines
          let yrelaxed = relaxedLabels[j].y - yval; 

          return `translate(${50 + 10}, ${yrelaxed})`
        });

      //
      // automatic resize to make sure everything is visible -- nondetects, etc
      //
      let compound_id = data.compound.id;
      let svgEl = document.getElementById("id-svg-compound-"+compound_id);
      let bb = ssi_svgBBox(svgEl); //.getBBox(); // ignore FLOW error here -- https://github.com/facebook/flow/issues/3484
      if (svgEl) {
        svgEl.style.height = (Math.ceil(bb.y + bb.height)+5) + "px";
        svgEl.style.width =  (Math.ceil(bb.x + bb.width)) + "px";
        console.log("resized "+compound_id+" w="+svgEl.style.width+" h="+svgEl.style.height)
      }
    
      this.add_popovers();

  } /* end render() */

  add_popovers() : void {
    $(".poplabel").popover({
        html: true,
        trigger: "manual",
        animation: false
    }).on("mouseenter", function(this: any) {
      var _this = this;
      $(this).popover("show");
      $(".popover").on("mouseleave", function() {
        $(_this).popover('hide');
      });
    }).on("mouseleave", function(this: any) {
      var _this = this;
      setTimeout(function() {
        if (!$(".popover:hover").length) {
          $(_this).popover("hide");
        }
      }, 300);
    });
  } /* end add_popovers */

} /* end class Graph */

export default Graph;
